// Minimal theme JS
document.addEventListener('change', async (e) => {
  const t = e.target;
  if (t.matches('[data-cart-qty]')) {
    const line = t.dataset.line;
    const qty = parseInt(t.value, 10);
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity: qty })
    });
    if (res.ok) location.reload();
  }
});

document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (form.matches('[data-product-form]')) {
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    const formData = new FormData(form);
    const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
    if (res.ok) {
      window.location.href = '/cart';
    } else {
      const err = await res.json().catch(() => ({}));
      alert(err.description || 'Could not add to cart');
      if (btn) btn.disabled = false;
    }
  }
});
